module.exports = __webpack_public_path__ + "img/left-static-desktop.476534e.webp";